export default "__VITE_ASSET__DMPLOXDy__"